var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49984 0.875C7.75962 0.875 8.9678 1.37545 9.85859 2.26624C10.7494 3.15704 11.2498 4.36522 11.2498 5.625V7.20833H12.8332V15.9167H6.49984H0.166504V7.20833H1.74984V5.625C1.74984 4.36522 2.25028 3.15704 3.14108 2.26624C4.03188 1.37545 5.24006 0.875 6.49984 0.875ZM6.49984 4.04167C6.11203 4.04172 5.73772 4.1841 5.44791 4.4418C5.15811 4.6995 4.97296 5.0546 4.92759 5.43975L4.9165 5.625V7.20833H8.08317V5.625C8.08312 5.23719 7.94074 4.86288 7.68304 4.57308C7.42534 4.28327 7.07023 4.09812 6.68509 4.05275L6.49984 4.04167Z",
    fill: "#FEC492"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0ffc7d04.svg";
export { ForwardRef as ReactComponent };